import "../css"
import "./fontawesome"

addEventListener("turbo:load", function() {
  $('[data-toggle="tooltip"]').tooltip()
})
